module.exports = __webpack_public_path__ + "assets/img/9_96_big.606d851e.jpg";